import { resetUserProfileSlice, updateUserProfile, userProfileDefaultValue } from "appRedux/slices/userSlice"
import { resetGlobalSlice } from "appRedux/slices/globalSlice"
import { resetNotificationSlice } from "appRedux/slices/notificationSlice"
import { resetExploreSlice } from "appRedux/slices/exploreSlice"
import { resetItemFormSlice } from "appRedux/slices/itemFormSlice"
import { resetListFormSlice } from "appRedux/slices/listFormSlice"
import { resetProfileTabsSlice } from "appRedux/slices/profileTabsSlice"
import { resetWishListSlice } from "appRedux/slices/wishListSlice"
import { resetFeedSlice } from "appRedux/slices/feedSlice"
import { resetPremiumSlice } from "appRedux/slices/premiumSlice"
import { resetOrderSlice } from "appRedux/slices/orderSlice"
import { resetInitSlice } from "appRedux/slices/initSlice"
import { premiumApi } from "appRedux/slices/premiumApiSlice"

export async function handleOnRegisterQueryStarted(body: any, { dispatch, queryFulfilled, getState }: any) {
  try {
    await queryFulfilled
    if (!body.username) return
    // @ts-ignore
    dispatch(updateUserProfile({
      ...userProfileDefaultValue,
      handle: body.username || ""
    }))
  } catch (error) {
    console.error("Error happened in register. Error: ", error)
  }
}

export async function handleOnLoginQueryStarted(body: any, { dispatch, queryFulfilled, getState }: any) {
  try {
    await queryFulfilled
    if (!body.username) return
    // @ts-ignore
    dispatch(updateUserProfile({
      ...userProfileDefaultValue,
      handle: body.username || ""
    }))
  } catch (error) {
    console.error("Error happened in login. Error: ", error)
  }
}

export async function handleOnLogOutQueryStarted(arg: any, { dispatch, queryFulfilled, getState }: any) {
  try {
    await queryFulfilled
    dispatch(resetExploreSlice())
    dispatch(resetFeedSlice())
    dispatch(resetGlobalSlice())
    dispatch(resetInitSlice())
    dispatch(resetItemFormSlice())
    dispatch(resetListFormSlice())
    dispatch(resetNotificationSlice())
    dispatch(resetOrderSlice())
    dispatch(resetPremiumSlice())
    dispatch(resetProfileTabsSlice())
    dispatch(resetUserProfileSlice())
    dispatch(resetWishListSlice())

    dispatch(premiumApi.util.resetApiState())
  } catch (error) {
    console.error("Error happened in logout. Error: ", error)
  }
}
